import React from "react";
import { SortContext } from "./SortContext";

export default class AdvancedList extends React.Component {

	static id = 1;

	constructor(props) {
		super(props);
		this.state = {
			page: 1,
			data: props.data ? [...props.data] : null,
			sortBy: [[null, 1], [null, 1], [null, 1]],
			search: ''
		};
		this.htmlId = "al" + AdvancedList.id++;
		this.pageSize = props.pageSize || 50;
		this.sortButtons = {};
		this.sorted = [];
		this.loaded = false;
		if (props.data)
			this.loaded = true;
	}

	componentDidUpdate(prevProps) {
		if (prevProps.data !== this.props.data) {
			if (this.props.selectable && this.props.selectable !== true)
				this.props.data.map(row => row.alSelected = row[this.props.selectable]);
			this.sorted = [...this.props.data];
			this.setState({ data: this.sorted, sortBy: [[null, 1], [null, 1], [null, 1]] });
			if (prevProps.data)
				this.loadState();
		} else if (!this.loaded && this.props.data)
			this.loadState();
	}

	initSort = (sortButton) => {
		this.sortButtons[sortButton.props.name] = sortButton;
		if (sortButton.props.default)
			this.onSort(sortButton, sortButton.props.desc);
	}

	onSort = (button, desc) => {
		let direction = desc ? -1 : 1;
		let sortBy = button.props.propertyName;
		let sortByNew = this.state.sortBy;
		let fixed = this.props.fixedPropertyName;
		if (this.state.sortBy[0][0] == button.props.name) {
			direction = this.state.sortBy[0][1] * -1;
			sortByNew[0][1] *= -1;
		} else {
			sortByNew[2] = sortByNew[1];
			sortByNew[1] = sortByNew[0];
			sortByNew[0] = [button.props.name, direction];
		}
		let data = [...this.props.data];
		//let data = this.sorted;
		data.sort((a, b) => {
			if (a[fixed] || b[fixed])
				return (b[fixed] || 0) - (a[fixed] || 0);
			else if (button.props.isNumber)
				return direction * ((a[sortBy] || 0) - (b[sortBy] || 0));
			else
				return direction * (a[sortBy] ?? '').localeCompare(b[sortBy] ?? '');
		})
		Object.keys(this.sortButtons).map(i => {
			let item = this.sortButtons[i];
			if (item.props.name == button.props.name)
				item.setState({ direction: direction });
			else
				item.setState({ direction: 0 });
		});
		this.sorted = data;
		data = this.filterData(data, this.state.search);
		//if (this.loaded) {
		this.setState({ data: data, page: 1, sortBy: sortByNew }, this.saveState);
		//}
	}

	onFilter = (button, filter) => {
		let data = this.filterData(this.sorted, this.state.search);
		this.setState({ data: data, page: 1 }, this.saveState);
		button.setState({ filter: filter });
	}

	searchChanged = (e) => {
		this.searchText(e.target.value);
	}
	searchText = (text) => {
		let data = this.filterData(this.sorted, text);
		this.setState({ data: data, search: text, page: 1 }, this.saveState);
	}

	filterData = (data, search) => {
		Object.keys(this.sortButtons).map(i => {
			let item = this.sortButtons[i];
			if (item.props.filterPropertyName)
				data = data.filter(item.filterItem);
		});

		if (!this.props.searchProperties || !search)
			return data;

		search = search.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
		let re = new RegExp(search, "i");
		return data.filter(item => {
			for (let i in this.props.searchProperties)
				if (item[this.props.searchProperties[i]] != null && item[this.props.searchProperties[i]].normalize("NFD").replace(/[\u0300-\u036f]/g, "").match(re))
					return true;
			return false;
		});
	}

	pageChanged = (e, page) => {
		if (e) e.preventDefault();
		// if ($("a[name='" + this.htmlId + "']").length) {
		//     // var top = $("a[name='" + this.htmlId + "']").offset().top - $('#pageContent').offset().top;
		//     var top = 0;
		//     $([document.documentElement, document.body]).animate({ scrollTop: top }, 500)
		// }
		this.setState({ page: page }, this.saveState);
		return false;
	}

	loadState = () => {
		this.loaded = false;
		this.sorted = this.props.data ? [...this.props.data] : null;
		if (this.props.name) {
			let states = JSON.parse(localStorage.getItem('advancedList'));
			if (states && states[this.props.name]) {
				this.state.sortBy = [[null, 1], [null, 1], [null, 1]];
				states = states[this.props.name];
				for (let i = 2; i >= 0; i--) {
					let sortBy = states[0][i];
					if (sortBy[0] && this.sortButtons[sortBy[0]])
						this.onSort(this.sortButtons[sortBy[0]], sortBy[1] == -1);
				}
				if (states.length > 3)
					Object.keys(states[3]).map(i => {
						if (this.sortButtons[i]) {
							this.sortButtons[i].setState({ filter: states[3][i] }, () => {
								this.onFilter(this.sortButtons[i], states[3][i]);
							});
						}
					});
				this.searchText(states[1]);
				this.pageChanged(null, states[2]);
			}
		}
		else
			this.setState({ data: this.sorted });
		this.loaded = true;
	}

	saveState = () => {
		if (!this.loaded || !this.props.name) return;
		let states = JSON.parse(localStorage.getItem('advancedList'));
		if (!states) states = {};
		let filters = {};
		Object.keys(this.sortButtons).map(i => {
			let item = this.sortButtons[i];
			if (item.state.filter.length)
				filters[i] = item.state.filter;
		});
		states[this.props.name] = [this.state.sortBy, this.state.search, this.state.page, filters];
		localStorage.setItem('advancedList', JSON.stringify(states));
	}

	selectAll = (e) => {
		this.state.data.map(row => row.alSelected = e.target.checked);
		this.forceUpdate();
		if (this.props.onSelectedChanged) this.props.onSelectedChanged();
	}

	getSelected = () => {
		return this.sorted.filter(row => row.alSelected);
	}

	alSelectedChanged = (e, row) => {
		row.alSelected = e.target.checked;
		this.forceUpdate();
		if (this.props.onSelectedChanged) this.props.onSelectedChanged();
	}

	reset = () => {
		let states = JSON.parse(localStorage.getItem('advancedList'));
		if (states && states[this.props.name]) {
			delete (states[this.props.name]);
			localStorage.setItem('advancedList', JSON.stringify(states));
			this.state.sortBy = [[null, 1], [null, 1], [null, 1]];
			this.setState({ search: '', page: 1 });
			Object.keys(this.sortButtons).map(i => {
				let item = this.sortButtons[i];
				item.setState({ filter: [], filtered: false });
				item.state.filter = [];
				setTimeout(() => this.initSort(item), 0);
			});
		}
	}

	render() {
		if (!this.state.data) {
			return false;
		}
		const pages = Math.ceil(this.state.data.length / this.pageSize);

		const searchBar =
			<div className="input-group">
				<input type="text" className="form-control form-control-sm" placeholder={t.commonSearch} value={this.state.search} onChange={this.searchChanged} />
				<span className="input-group-text" onClick={() => this.searchText("")}><em className="fa-solid fa-remove"></em></span>
			</div>

		const pagination = <ul className="pagination pagination-sm m-0">
			<li className={"page-item" + (this.state.page == 1 ? " disabled" : "")}><a className="page-link" href={"#" + this.htmlId} onClick={(e) => this.pageChanged(e, 1)}><em className="fa-solid fa-angles-left"></em></a></li>
			<li className={"page-item" + (this.state.page == 1 ? " disabled" : "")}><a className="page-link" href={"#" + this.htmlId} onClick={(e) => this.pageChanged(e, this.state.page - 1)}><em className="fa-solid fa-angle-left"></em></a></li>
			<li className="page-item"><span className="page-link text-body">{(this.state.page - 1) * this.pageSize + 1} - {(this.state.page - 1) * this.pageSize + this.state.data.slice(this.pageSize * this.state.page - this.pageSize, this.pageSize * this.state.page).length} / {this.state.data.length}</span></li>
			<li className={"page-item" + (this.state.page > pages - 1 ? " disabled" : "")}><a className="page-link" href={"#" + this.htmlId} onClick={(e) => this.pageChanged(e, this.state.page + 1)}><em className="fa-solid fa-angle-right"></em></a></li>
			<li className={"page-item" + (this.state.page > pages - 1 ? " disabled" : "")}><a className="page-link" href={"#" + this.htmlId} onClick={(e) => this.pageChanged(e, pages)}><em className="fa-solid fa-angles-right"></em></a></li>
		</ul>

		// const Row = (row, i) => {
		//     if (this.props.selectable || this.props.renderCells) {
		//         if (this.props.selectable && this.props.selectable !== true && row.alSelected === undefined)
		//             row.alSelected = row[this.props.selectable];
		//         if (this.props.getLink)
		//             return <Link key={i} to={this.props.getLink(row)} className="nk-tb-item">
		//                 {this.props.selectable && <div className="nk-tb-col nk-tb-col-check" onClick={(e) => {
		//                     e.stopPropagation();
		//                     return false;
		//                 }}>
		//                     <div className="custom-control custom-control-sm custom-checkbox" style={{pointerEvents: 'none'}}>
		//                         <input type="checkbox" className="custom-control-input" id={this.htmlId + i} checked={row.alSelected} onChange={(e) => this.alSelectedChanged(e, row)}/>
		//                         <label className="custom-control-label" htmlFor={this.htmlId + i} style={{pointerEvents: 'all'}}></label>
		//                     </div>
		//                 </div>}
		//                 {this.props.renderCells(row)}
		//             </Link>
		//         else
		//             return <div key={i} className="nk-tb-item">
		//                 {this.props.selectable && <div className="nk-tb-col nk-tb-col-check" onClick={(e) => {
		//                     e.stopPropagation();
		//                     return false;
		//                 }}>
		//                     <div className="custom-control custom-control-sm custom-checkbox" style={{pointerEvents: 'none'}}>
		//                         <input type="checkbox" className="custom-control-input" id={this.htmlId + i} checked={row.alSelected} onChange={(e) => this.alSelectedChanged(e, row)}/>
		//                         <label className="custom-control-label" htmlFor={this.htmlId + i} style={{pointerEvents: 'all'}}></label>
		//                     </div>
		//                 </div>}
		//                 {this.props.renderCells(row)}
		//             </div>
		//     } else
		//         return <Fragment key={i}>{this.props.renderRow(row)}</Fragment>
		// }

		return (
			<SortContext.Provider value={{ onSort: this.onSort, initSort: this.initSort, onFilter: this.onFilter }}>

				<div className="card mb-4">
					<div className="card-header d-flex justify-content-between p-1 align-items-baseline">
						<div>{this.props.searchProperties ? searchBar : ""}</div>
						<div className="ms-2 me-auto">{this.props.listHeader}</div>
						<div>
							<a name={this.htmlId} />
							{pagination}
						</div>
					</div>
					<div className="card-body p-0">
						{this.props.isList ?
							<>
								{this.props.header}
								<ul className="list-group">
									{this.state.data && this.state.data.slice(this.pageSize * this.state.page - this.pageSize, this.pageSize * this.state.page).map((row, i) => <li key={i} className="list-group-item list-group-item-action">{this.props.renderRow(row)}</li>)}
								</ul>
							</> :
							<table className="table table-hover mb-0">
								<thead>
									{this.props.header}
								</thead>
								<tbody>
									{this.state.data && this.state.data.slice(this.pageSize * this.state.page - this.pageSize, this.pageSize * this.state.page).map((row, i) =>
										this.props.renderRow ? this.props.renderRow(row) :
											<tr onClick={this.props.onRowClick ? () => this.props.onRowClick(row) : null} key={i} className={(this.props.onRowClick ? "pointer" : '') + (this.props.rowClass ? ' ' + this.props.rowClass(row) : '')}>{this.props.renderCells(row).map((cell, j) => <td key={j} style={Array.isArray(cell) ? cell[1] : null}>{Array.isArray(cell) ? cell[0] : cell}</td>)}</tr>)}
								</tbody>
							</table>}
					</div>

					{/*!this.props.isTable && <>
                        {this.props.selectable && <div className="nk-tb-col nk-tb-col-check bg-gray border border-gray">
                            <div className="custom-control custom-control-sm custom-checkbox">
                                <input type="checkbox" className="custom-control-input" id={this.htmlId + 'all'} onChange={this.selectAll}/>
                                <label className="custom-control-label" htmlFor={this.htmlId + 'all'}></label>
                                {this.props.selectable && this.props.selectable !== true && <SortButton name={this.props.selectable} propertyName="alSelected"/>}
                            </div>
                        </div>}
                        {this.props.header}

                        {this.state.data && this.state.data.slice(this.pageSize * this.state.page - this.pageSize, this.pageSize * this.state.page).map((row, i) =>
                            Row(row, i)
                        )}
                    </>}
                    {this.props.isTable && <>
                        <table className="table border table-bordered">
                            <thead>
                            {this.props.header}
                            </thead>
                            <tbody className="fs-12px">
                            {this.state.data && this.state.data.slice(this.pageSize * this.state.page - this.pageSize, this.pageSize * this.state.page).map((row, i) =>
                                Row(row, i)
                            )}
                            </tbody>
                        </table>
                    </>*/}
					{pages > 0 && <div className="card-footer d-flex justify-content-end border-top-0 p-1">{pagination}</div>}
				</div>
			</SortContext.Provider>
		);
	}
}